/* HOME DESIGN LAB — theme behaviour (no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Header: subtle border on scroll ---------- */
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    var update = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  /* ---------- Mobile drawer ---------- */
  function initDrawer() {
    document.querySelectorAll('[data-drawer]').forEach(function (drawer) {
      var summary = drawer.querySelector('summary');
      drawer.addEventListener('toggle', function () {
        document.body.classList.toggle('is-locked', drawer.open);
        if (summary) summary.setAttribute('aria-expanded', drawer.open);
        if (drawer.open) {
          var first = drawer.querySelector('.drawer__panel a, .drawer__panel button');
          if (first) first.focus();
        }
      });
      drawer.querySelectorAll('[data-drawer-close]').forEach(function (btn) {
        btn.addEventListener('click', function () { drawer.open = false; if (summary) summary.focus(); });
      });
      drawer.querySelectorAll('.drawer__panel a[href^="#"]').forEach(function (a) {
        a.addEventListener('click', function () { drawer.open = false; });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && drawer.open) { drawer.open = false; if (summary) summary.focus(); }
      });
    });
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('[data-reveal]');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) { entry.target.classList.add('is-visible'); io.unobserve(entry.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Before / after sliders ---------- */
  function initBeforeAfter(root) {
    (root || document).querySelectorAll('[data-ba]').forEach(function (ba) {
      var range = ba.querySelector('input[type="range"]');
      if (!range || ba.dataset.baReady) return;
      ba.dataset.baReady = '1';
      var set = function () {
        ba.style.setProperty('--pos', range.value + '%');
        range.setAttribute('aria-valuetext', range.value + '% before image shown');
      };
      range.addEventListener('input', set);
      // Drag anywhere on the image (mouse, touch, pen) – not only on the handle
      var dragging = false;
      var move = function (e) {
        var r = ba.getBoundingClientRect();
        var pct = Math.round(Math.min(100, Math.max(0, ((e.clientX - r.left) / r.width) * 100)));
        range.value = pct; set();
      };
      ba.addEventListener('pointerdown', function (e) {
        dragging = true; move(e);
        if (ba.setPointerCapture) ba.setPointerCapture(e.pointerId);
      });
      ba.addEventListener('pointermove', function (e) { if (dragging) { e.preventDefault(); move(e); } });
      ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (t) {
        ba.addEventListener(t, function () { dragging = false; });
      });
      set();
    });
  }

  /* ---------- Lightbox (preview pages + product gallery) ---------- */
  var lightbox, lbImg, lbCap, lbItems = [], lbIndex = 0, lbReturn = null;
  function initLightbox() {
    lightbox = document.querySelector('[data-lightbox-dialog]');
    if (!lightbox || typeof lightbox.showModal !== 'function') return;
    lbImg = lightbox.querySelector('img');
    lbCap = lightbox.querySelector('[data-lightbox-caption]');

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-lightbox]');
      if (!trigger) return;
      e.preventDefault();
      var group = trigger.getAttribute('data-lightbox');
      lbItems = Array.prototype.slice.call(document.querySelectorAll('[data-lightbox="' + group + '"]'));
      lbIndex = Math.max(0, lbItems.indexOf(trigger));
      lbReturn = trigger;
      show();
      lightbox.showModal();
      document.body.classList.add('is-locked');
    });
    lightbox.querySelector('[data-lightbox-close]').addEventListener('click', function () { lightbox.close(); });
    lightbox.querySelector('[data-lightbox-prev]').addEventListener('click', function () { step(-1); });
    lightbox.querySelector('[data-lightbox-next]').addEventListener('click', function () { step(1); });
    lightbox.addEventListener('click', function (e) { if (e.target === lightbox) lightbox.close(); });
    lightbox.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') step(1);
      if (e.key === 'ArrowLeft') step(-1);
    });
    lightbox.addEventListener('close', function () {
      document.body.classList.remove('is-locked');
      if (lbReturn) lbReturn.focus();
    });
    var startX = null;
    lightbox.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', function (e) {
      if (startX === null) return;
      var dx = e.changedTouches[0].clientX - startX;
      if (Math.abs(dx) > 50) step(dx < 0 ? 1 : -1);
      startX = null;
    });
  }
  function show() {
    var item = lbItems[lbIndex];
    if (!item) return;
    lbImg.src = item.getAttribute('data-full');
    lbImg.alt = item.getAttribute('data-alt') || '';
    lbCap.textContent = (item.getAttribute('data-caption') || '') + (lbItems.length > 1 ? '  ·  ' + (lbIndex + 1) + ' / ' + lbItems.length : '');
    var multi = lbItems.length > 1;
    lightbox.querySelector('[data-lightbox-prev]').hidden = !multi;
    lightbox.querySelector('[data-lightbox-next]').hidden = !multi;
  }
  function step(d) { lbIndex = (lbIndex + d + lbItems.length) % lbItems.length; show(); }

  /* ---------- Product gallery ---------- */
  function initGallery(root) {
    (root || document).querySelectorAll('[data-gallery]').forEach(function (gallery) {
      var slides = gallery.querySelectorAll('[data-slide]');
      var thumbs = gallery.querySelectorAll('[data-thumb]');
      thumbs.forEach(function (thumb, i) {
        thumb.addEventListener('click', function () {
          slides.forEach(function (s, j) { s.classList.toggle('is-active', i === j); s.setAttribute('aria-hidden', i !== j); });
          thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j ? 'true' : 'false'); });
        });
      });
      var main = gallery.querySelector('.gallery__main');
      var x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) < 50 || thumbs.length < 2) return;
          var cur = Array.prototype.findIndex.call(thumbs, function (t) { return t.getAttribute('aria-current') === 'true'; });
          var next = (cur + (dx < 0 ? 1 : -1) + thumbs.length) % thumbs.length;
          thumbs[next].click();
        });
      }
    });
  }

  /* ---------- Buy forms: prevent double submit ---------- */
  function initBuyForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-buy-form]')) return;
      if (form.dataset.submitting) { e.preventDefault(); return; }
      form.dataset.submitting = '1';
      var btn = form.querySelector('[type="submit"]');
      if (btn) {
        btn.classList.add('is-loading');
        btn.setAttribute('aria-busy', 'true');
        var label = btn.querySelector('.btn__label');
        if (label && btn.dataset.loadingLabel) label.textContent = btn.dataset.loadingLabel;
      }
      // Restore if the user navigates back (bfcache)
      window.addEventListener('pageshow', function () {
        delete form.dataset.submitting;
        if (btn) { btn.classList.remove('is-loading'); btn.removeAttribute('aria-busy'); }
      }, { once: true });
    });
  }

  /* ---------- Sticky mobile CTA ---------- */
  function initSticky() {
    var bar = document.querySelector('[data-sticky-cta]');
    if (!bar) return;
    var anchors = document.querySelectorAll('[data-buy-anchor]');
    var footer = document.querySelector('.footer');
    var visibleAnchors = new Set();
    var footerVisible = false;
    var update = function () {
      var past = window.scrollY > Math.min(560, window.innerHeight * 0.7);
      var show = past && visibleAnchors.size === 0 && !footerVisible;
      bar.classList.toggle('is-visible', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      bar.querySelectorAll('a, button').forEach(function (el) { el.tabIndex = show ? 0 : -1; });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (en.target === footer) footerVisible = en.isIntersecting;
          else if (en.isIntersecting) visibleAnchors.add(en.target);
          else visibleAnchors.delete(en.target);
        });
        update();
      });
      anchors.forEach(function (a) { io.observe(a); });
      if (footer) io.observe(footer);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ---------- Cart quantity steppers ---------- */
  function initQty() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      var input = b.parentElement.querySelector('input');
      var v = parseInt(input.value, 10) || 0;
      input.value = Math.max(0, v + parseInt(b.getAttribute('data-qty'), 10));
      if (input.form) input.form.requestSubmit ? input.form.requestSubmit() : input.form.submit();
    });
  }

  function init() {
    initHeader(); initDrawer(); initReveal(); initBeforeAfter(); initLightbox();
    initGallery(); initBuyForms(); initSticky(); initQty();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  /* ---------- Theme editor support ---------- */
  document.addEventListener('shopify:section:load', function (e) {
    initBeforeAfter(e.target); initGallery(e.target);
    e.target.querySelectorAll('[data-reveal]').forEach(function (el) { el.classList.add('is-visible'); });
  });
})();
